import React from 'react'
import styled, { css } from 'styled-components'

interface Props {
  ratio: '16:9' | '4:3' | '3:2' | '8:5' | '1:1',
  children: any;
}

const RATIOS_TO_PADDING = {
  '16:9': '56.25%',
  '4:3': '75%',
  '3:2': '66.66%',
  '8:5': '62.5%',
  '1:1': '100%'
}
const Wrapper = styled.div`
  position: relative;
  width: 100%;
  ${(props: Props) => css`
    padding-bottom: ${RATIOS_TO_PADDING[props.ratio]};
  `}
`

const Content = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`

export default (props: Props) => <Wrapper ratio={props.ratio}>
  <Content>{props.children}</Content>
</Wrapper>

